// extracted by mini-css-extract-plugin
module.exports = {"comment":"Comment_comment__2g_en","title":"Comment_title__3zBjr","content":"Comment_content__379nM"};